import React, { useState, useMemo } from "react";
import EmbedUploader from "components/Reusable/JUMBOform/EmbedUploader/EmbedUploader.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import EmbedFormTemplateBody from "./EmbedFormTemplateBody.js";
import EmbedFormTemplateFooter from "./EmbedFormTemplateFooter.js";
import EmbedFormTemplateFaileds from "./EmbedFormTemplateFaileds.js";
import Image from "components/Elements/Image/Image.tsx";
import { checkIfColorIsDark } from "../Helpers/ValidationFunctions.js";

const EmbedFormTemplateContainer = ({
  activeForm,
  allowUseForm,
  notExistForm,
  isPreview,
  direction,
  formInEmbedPage,
  width,
  height,
  formDetails,
  loading,
  displayPreview,
  startUpload,
  buttonBackgroundColor,
  setStartUpload,
  embedMailId,
  setEmbedMailId,
  finishUpload,
  setFinishUpload,
  handleFinishUploadProcess,
  backgroundFormColor,
  hideFooter,
  tidParam,
  hideDetails,
  includeTitleAndDesc,
  displayImageForm,
  formImage,
  displayTitleForm,
  formTitle,
  displayDescriptionForm,
  formDescription,
  embedJson,
  errorFields,
  setEmbedJson,
  prevCookies,
  createEmbedMail,
  buttonTextColor,
  loadingButton,
  searchParams,
  displayFooterLinks,
  linkFooters,
  allowUseFormText,
  loadingCulture,
  isDemoEmbedPage,
  typeUser,
  embedPageEditMode,
  maxFormHeight,
  innerScrollHeight,
  skipFormParam,
  setReSendMail,
  skipForm,
}) => {
  const { mobileCondition } = useMediaQueries();
  const [notActiveState, setNotActiveState] = useState(false);
  useMemo(() => {
    if (!activeForm || !allowUseForm || notExistForm) {
      setNotActiveState(true);
    } else {
      setNotActiveState(false);
    }
  }, [activeForm, allowUseForm, notExistForm]);
  //check if is inside iframe and if yes, check the height of the iframe
  const isInsideIframe = window.self !== window.top;
  const iframeHeight = window.innerHeight;
  return (
    <div
      className={`embed-dynamic-template ${
        notActiveState && !isPreview ? "not-active-form" : ""
      } ${direction === "rtl" ? "right-to-left" : "left-to-right"} ${
        startUpload && isInsideIframe ? "uploader-mode-container" : ""
      }`}
      style={{
        width: !mobileCondition && !formInEmbedPage ? width : "unset",
      }}
    >
      {formDetails && !notActiveState && displayPreview && (
        <div
          className={`embed-dynamic-container ${
            checkIfColorIsDark(backgroundFormColor) ? "dark-background" : ""
          }`}
          style={{
            backgroundColor: backgroundFormColor,
          }}
        >
          {startUpload || skipForm ? (
            <EmbedUploader
              backgroundColor={backgroundFormColor}
              buttonsColor={buttonBackgroundColor}
              setStartUpload={setStartUpload}
              formDetails={formDetails}
              embedMailId={embedMailId}
              setEmbedMailId={setEmbedMailId}
              finishUpload={finishUpload}
              setFinishUpload={setFinishUpload}
              handleFinishUploadProcess={handleFinishUploadProcess}
              hideFooter={hideFooter}
              tidParam={tidParam}
              isInsideIframe={isInsideIframe}
              setReSendMail={setReSendMail}
            />
          ) : (
            <>
              <EmbedFormTemplateBody
                typeUser={typeUser}
                formDetails={formDetails}
                hideDetails={hideDetails}
                includeTitleAndDesc={includeTitleAndDesc}
                displayImageForm={displayImageForm}
                formImage={formImage}
                displayTitleForm={displayTitleForm}
                formTitle={formTitle}
                displayDescriptionForm={displayDescriptionForm}
                formDescription={formDescription}
                embedJson={embedJson}
                direction={direction}
                errorFields={errorFields}
                setEmbedJson={setEmbedJson}
                buttonBackgroundColor={buttonBackgroundColor}
                prevCookies={prevCookies}
                createEmbedMail={createEmbedMail}
                buttonTextColor={buttonTextColor}
                loadingButton={loadingButton}
                searchParams={searchParams}
                isDemoEmbedPage={isDemoEmbedPage}
                isPreview={isPreview}
                embedPageEditMode={embedPageEditMode}
                formInEmbedPage={formInEmbedPage}
                maxFormHeight={maxFormHeight}
                innerScrollHeight={innerScrollHeight}
                displayFooterLinks={displayFooterLinks}
                isInsideIframe={isInsideIframe}
                iframeHeight={iframeHeight}
              />
              {displayFooterLinks && (
                <EmbedFormTemplateFooter linkFooters={linkFooters} />
              )}
            </>
          )}
        </div>
      )}
      {notActiveState && (
        <EmbedFormTemplateFaileds
          allowUseForm={allowUseForm}
          loading={loading}
          isPreview={isPreview}
          allowUseFormText={allowUseFormText}
          activeForm={activeForm}
          notExistForm={notExistForm}
        />
      )}
      {loading || loadingCulture ? (
        <div
          className="loading-container-form"
          style={{
            height: `${isInsideIframe ? iframeHeight : height}px`,
            width: `${width}px`,
          }}
        >
          <Image alt="" title="" name="preloader" ext="gif" />
        </div>
      ) : null}
    </div>
  );
};

export default EmbedFormTemplateContainer;
